<template>
  <div class="container">

    <div class="banner">
      <div class="inner_center">
        <h1>提供商用版权保障 更多企业的放心选择</h1>
        <a :href="PAY_COMPANY" target="_blank" class="get-copyright"
           @click="tag('充值:企业案例授权:图片');"
        >获取版权保障</a>
        <div class="enterprise-case-tip">
          *以下为潮国创意合作企业和案例，为保障企业广告版权，部分企业不做具体案例展示。
        </div>
      </div>
    </div>


    <div class="content inner_center">
      <!-- 分类 -->
      <div class="category">
        <div class="category-item"
             :class="{ 'ON': categoryId == item.id }"
             v-for="item in category" :key="item.id"
             @click="toggleCategory(item)"
        >
          {{ item.name }}
        </div>
      </div>

      <!-- 列表 -->
      <div class="case-list" :class="{ 'ON': page >= pages }">
        <div class="case-item"
             v-for="item in caseList"
             :key="item.id"
             @click="toCaseDetail(item)"
        >
         <div class="case-img-box">
           <img class="case-img" :src="item._logo" alt="">
         </div>

          <div class="case-name">{{ item.company }}</div>

          <!-- 查看案例 -->
          <div
            class="case-watch" v-if="item.is_case == 1"
          >查看案例
          </div>
        </div>
      </div>

      <div class="case-more" v-if="page < pages"
           @click="loadMoreCase"
      >
        查看更多案例
      </div>


    </div>

    <div class="company-bar">
      <HeaderWrap
        calss="HeaderWrap"
      />

      <div class=" tab-box">
        <div class="tab">
          <div class="tab-bar" :style="{left: (9 + active * 319 )+ 'px'}"/>


          <div class="tab-item"
               v-for="(item,index) in [
               {id: 1,title: '中小微企业授权', desc: '适用于公司人数≤1000人 | 线上线下'},
               {id: 2,title: '企业PLUS授权', desc: '适用于大型企业 | 国企 | 事业单位 | 定制版授权'},
             ]"
               :key="item.title"
               @mouseover="active = index"
               @click="toCompanyPlus(item)"
          >
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>

      </div>

      <CompanyVipCardGroup
        @buy="buy"
        @showCertificate="showCertificate"
      />

      <a class="watch-scope"
         :href="INTRODUCE_COMPANY_VIP"
         target="_blank"
      >查看详细授权范围 <i class="iconfont icon-a-arrowright3"/></a>
    </div>


  </div>
</template>

<script>
import {getEnterpriseCaseList, getEnterpriseCategory} from "@/api/enterprise";
import {
  BASE_IMG_URL,
  ENTERPRISE_CASE,
  ENTERPRISE_CASE_DETAIL,
  INTRODUCE_COMPANY_VIP,
  PAY_COMPANY
} from "@/constant/_constant/CON_BASIC";
import {HeaderWrap} from "@/components/introduce/company";
import * as fnCommon from "@/fn/_fn";
import {tag} from "@/utils/statUtil";
import {flowStatistics} from "@/api/flow-statistics";

import {
  CompanyVipCardGroup,
} from "@/components/introduce/company";

import {PAY} from "@/constant/PATH";

export default {
  name: "EnterpriseCase",
  layout: "header-nav",
  components: {
    HeaderWrap,
    CompanyVipCardGroup
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      category: [],
      categoryId: 0,
      caseList: [],
      active: 0,
      page: 1,
      pages: 0,
      PAY_COMPANY,
      PAY,
      INTRODUCE_COMPANY_VIP
    }
  },
  methods: {
    init() {
      this.getEnterpriseCategory();
      this.getEnterpriseCaseList();
      flowStatistics({position: 'companyCase'})
    },
    async getEnterpriseCategory() {
      let res = await getEnterpriseCategory();
      console.log(res)
      const {status, data, message} = res.data
      if (status === 200) {
        this.category = [{id: 0, name: '全部'}].concat(data);
      }
    },
    toggleCategory(item) {
      this.page = 1;
      this.categoryId = item.id;
      this.getEnterpriseCaseList('reset');
    },

    async getEnterpriseCaseList(type = 'add') {
      let res = await getEnterpriseCaseList({
        'categoryId': this.categoryId,
        'page': this.page,
        'limit': 16
      })
      const {status, data, message} = res.data
      if (status === 200) {
        if (type == 'add') {
          this.caseList = this.caseList.concat(data.list);
        } else {
          this.caseList = data.list
        }

        this.caseList.map(item => item._logo = BASE_IMG_URL + item.logo);
        console.log(this.caseList)
        this.page = data.page;
        this.pages = data.pages;
      }
    },

    loadMoreCase() {
      this.page = parseInt(this.page) + 1;
      this.getEnterpriseCaseList('add');
    },

    toCaseDetail(item) {
      if (item.is_case == 1) {
        fnCommon.fnBasic.navigationTo(`${ENTERPRISE_CASE_DETAIL}/${item.id}.html`)
      }
    },

    toCompanyPlus(item) {
      if (item.id == 2) {
        fnCommon.fnBasic.navigationTo('/introduce/company-plus')
      } else {
        fnCommon.fnBasic.navigationTo('/introduce/company')
      }
    },
    tag(stat) {
      tag(stat)
    },
    buy(vipInfo) {
      let link;
      if (vipInfo.ID === -999 || vipInfo.ID === -1) {
        link = this.serviceLink;
      } else {
        tag('充值:企业介绍页:图片')

        link = this.PAY + '/' + vipInfo.ID;
      }
      window.open(link, '_blank');

      this.$emit('buy', vipInfo)
    },

    showCertificate(idx) {
      console.log(idx)
      this.CertificateType = idx;
      this.$refs.CertificateDialog.show = true;
    },
  }
}
</script>

<style lang="scss" scoped>

/* common */
.inner_center {
  width: 1200px !important;
}

/* banner */
.banner {
  width: 100%;
  height: 440px;
  @include BgImage(100%, 440px, 'enterprise/banner.jpg', 1);

  .inner_center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h1 {
    height: 56px;
    font-size: 52px;
    font-weight: bold;
    color: #00001A;
    line-height: 56px;
    letter-spacing: 3px;
    padding: 130px 0 64px;
  }

  .get-copyright {
    width: 248px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    background: #255BFF;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing: 2px;
    margin-bottom: 96px;

    &:hover {
      background: #4472FF;
    }
  }

  .enterprise-case-tip {
    height: 16px;
    font-size: 12px;
    color: #989BAC;
    line-height: 16px;
  }
}

/* 内容 */
.content {
  padding-top: 40px;
  background: #FCFDFF;

  .category {
    display: flex;
    margin-bottom: 18px;
    flex-wrap: wrap;

    .category-item {
      width: 110px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #EBEDF5;
      margin-right: 22px;
      margin-bottom: 22px;
      cursor: pointer;

      &:hover{
        background: rgba(244, 247, 255, 1);
        border-color: rgba(244, 247, 255, 1);
        color: #255BFF;
      }

      &.ON {
        background: #255BFF;;
        color: #FFFFFF;
        border: 1px solid #255BFF;;

        &:hover {
          background: #4472FF;
        }
      }
    }
  }

  .case-list {
    display: flex;
    flex-wrap: wrap;

    &.ON {
      padding-bottom: 26px;
    }

    .case-item {
      width: 279px;
      height: 205px;
      background: #FFFFFF;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 26, 0.06);
      border-radius: 10px;
      margin: 0 28px 30px 0;
      overflow: hidden;
      position: relative;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .case-img-box{
        width: 100%;
        height: 150px;
        overflow: hidden;
        &:hover{
          .case-img {
            transform: scale(1.2);
          }
        }
      }

      .case-img {
        display: inline-block;
        width: 100%;
        height: 150px;
        vertical-align: middle;
        transition: all 0.5s ease-in-out;
      }

      .case-name {
        font-size: 16px;
        color: #2D2B33;
        text-align: center;
        line-height: 55px;
        height: 55px;
      }

      .case-watch {
        width: 64px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 0px 10px 0px 10px;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        color: #FFFFFF;
        cursor: pointer;
        background: rgba(0, 0, 0, 0.2);
        color: #FFFFFF;
      }
    }

  }

  .case-more {
    width: 180px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: rgba(37, 91, 255, 0.05);
    border-radius: 4px;
    border: 1px solid #255BFF;
    font-size: 14px;
    color: #255BFF;
    margin: 26px auto 56px;
    cursor: pointer;

    &:hover{
      background: #E9EEFF;
    }

  }
}

/* 企业 */
.company-bar {
  //height: 396px;
  position: relative;

  /deep/ .CompanyHeaderWrap {
    //height: 396px !important;
    background: linear-gradient(223deg, #404670 0%, #30385A 20%, #30385A 62%, #393E65 100%);

    .watch-scope {
      display: none;
    }
  }

  .tab-box {
    @include Position(1, 5, 50%, 257px);
    transform: translateX(-50%);

    .tab {
      width: 656px;
      height: 91px;
      background: #FFFFFF;
      box-shadow: 0px -2px 8px 0px rgba(234, 163, 70, 0.05);
      border-radius: 15px;
      border: 1px solid;
      padding: 8px 9px 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: relative;

      .tab-bar {
        @include BgImage2(319px, 76px, 'introduce/company/CompanyTabActive.png');
        display: flex !important;
        @include Position(1, 5, 8px, 8px);
        transition: all 0.3s ease;
      }

      .tab-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 319px;
        height: 76px;
        position: relative;
        z-index: 8;
        cursor: pointer;

        .title {
          font-size: 20px;
          font-weight: bold;
          color: #666666;
          line-height: 20px;
          margin-bottom: 13px;
        }

        .desc {
          font-size: 12px;
          color: #666666;
          line-height: 12px;
          letter-spacing: 1px;
        }

        &.on {

        }
      }
    }
  }


}

.watch-scope {
  transform: translateX(-50%);
  @include Position(1, 4, 50%, 50px);
  width: 165px;
  height: 36px;
  background: linear-gradient(270deg, rgba(66, 74, 113, 0.17) 0%, rgba(66, 74, 113, 0.6) 55%, rgba(66, 74, 113, 0.17) 100%);
  border-radius: 18px;
  font-size: 12px;
  color: #7D87B9;
  line-height: 16px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @include ElementHover(rgba(162, 171, 216, 1), linear-gradient(270deg, rgba(66, 74, 113, 0.17) 0%, rgba(66, 74, 113, 0.6) 55%, rgba(66, 74, 113, 0.17) 100%));

  .icon-a-arrowright3 {
    margin-left: 4px;
  }

}


</style>
